import React from "react";
import { useTranslation } from "react-i18next";
import BackArrowButton from "./back-arrow-button";

function SignupStepMarkerOrganization({
  active = 1,
  phrase,
  onBack,
  title,
  noBack = false,
}) {
  const { t } = useTranslation("auth");
  const displayTitle = title != null ? title : t("signupStepMarkerOrganization.signUp");
  return (
    <header role="onboarding-header">
      <section>
        {!noBack && <BackArrowButton onBack={onBack} text="" />}
        <h1>{displayTitle}</h1>
      </section>
      <ul>
        <li
          className={`step ${
            active === 1 ? "active" : active > 1 ? "completed" : ""
          }`}
        >
          {active === 1 ? phrase : "1"}
        </li>
        <li
          className={`step ${
            active === 2 ? "active" : active > 2 ? "completed" : ""
          }`}
        >
          {active === 2 ? phrase : "2"}
        </li>
        <li
          className={`step ${
            active === 3 ? "active" : active > 3 ? "completed" : ""
          }`}
        >
          {active === 3 ? phrase : "3"}
        </li>
      </ul>
    </header>
  );
}

export default SignupStepMarkerOrganization;
